import { CONTACT, STORES } from "../../content";
import { useT } from "../../i18n/LangContext";

// Hides itself automatically once a store link is set in content.js.
export const ComingSoonBanner = () => {
  const t = useT().banner;
  if (STORES.some((s) => s.href)) return null;
  return (
    <div className="bg-[#FFF6CC] px-5 py-2 text-center text-xs leading-snug text-black sm:text-sm" data-testid="coming-soon-banner">
      <span className="mr-1.5 inline-block h-2 w-2 rounded-full bg-[#FFD000] align-middle ring-2 ring-[#FFE680]" aria-hidden="true" />
      {t.text}{" "}
      <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="font-semibold underline underline-offset-2 hover:text-zinc-600" data-testid="coming-soon-banner-whatsapp">
        {t.link}
      </a>
    </div>
  );
};
